<template>
  <AppSection
    id="scope-setting"
    :is-section-loading="isLoading"
    :title="$route.name === $getConst.routesNames.administration.maintenanceConfig ? $getConst.pages.maintenance.maintenance_page_title: $getConst.pages.error.error_page_title"
    type="section"
  >
      <scopeSettingsForm
        :scope_id="scope_id"
        :scope_name="scope_name"
        @loading="(loading) => this.isLoading = loading"
      />
  </AppSection>
</template>

<script>
  import scopeSettingsForm from "./scopeSettingsForm";
  import AppSection from "../../../../components/common/sections/AppSection";
  export default {
    name: "index",
    components: {AppSection, scopeSettingsForm},
    props: {
      scope_id: null,
      scope_name: null,
    },
    data() {
      return {
        isLoading: false
      }
    }
  }
</script>

<style scoped>

</style>
